module.exports = __webpack_public_path__ + "img/1467454519.860f6127.jpg";